<template>
  <div class="page-view box-card">
    <!-- <div class="box-card-header">
      <div class="left">
        <div class="auth-remark" v-if="userInfo.auth_remark">
          <I18Lang id="public32" defaultText="审核失败" />：{{ userInfo.auth_remark }}
        </div>
      </div>
    </div> -->
    <div class="box-card-content">

      <div class="user-info" v-if="userInfo">
        <div class="user">
          <div class="avatar">
            <img src="" alt="">
          </div>
          <div class="info">
            <span class="nickname">{{ userInfo.username }}</span>
            <span class="user-id">
              <I18Lang id="index22" defaultText="Agent ID" />:{{ userInfo.account_id }}
            </span>
            <!-- <span class="info-tag" :class="`status${userInfo.auth_status}`"
              @click="$router.push({ name: userInfo.identity === 0 ? 'userInfo' : 'proxyInfo' })">{{ showAuthStatus
              }}</span> -->
          </div>
        </div>

      </div>

      <div class="content">
        <div class="left">

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="index23" defaultText="注册时间" />
            </div>
            <div class="form-item-value">{{ userInfo.reg_time }}</div>
          </div>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="index24" defaultText="邮箱" />
            </div>
            <div class="form-item-value">{{ userInfo.email }}</div>
          </div>

          <div class="form-item">
            <div class="form-item-label">
              <I18Lang id="index25" defaultText="登录密码" />
            </div>
            <div class="form-item-value">****** <div class="btn kg-btn4" @click="onShow('boxPassword')">
                <I18Lang id="proxymoney103" defaultText="修改" />
              </div>
            </div>
          </div>

          <BoxPassword ref="boxPassword" @onUpdata="onUpdata" />

        </div>
        <!-- <div class="right">
          <div class="bank-info">
            <span class="bank-info-title">
              <I18Lang id="user60" defaultText="银行信息" />
            </span>

            <div class="info-item" v-if="userInfo.bank_info">
              <div class="info-item-left">
                <div class="key">
                  <I18Lang id="user61" defaultText="开户人" />
                </div>
                <div class="value">{{ userInfo.bank_info.bank_user }}</div>
              </div>
              <div class="info-item-right kg-btn4" @click="onShow('boxBank')">
                <I18Lang id="proxymoney103" defaultText="修改" />
              </div>
            </div>

            <div class="info-item" v-if="userInfo.bank_info">
              <div class="info-item-left">
                <div class="key">
                  <I18Lang id="user62" defaultText="银行名称" />
                </div>
                <div class="value">{{ userInfo.bank_info.bank_name }}</div>
              </div>

            </div>

            <div class="info-item" v-if="userInfo.bank_info">
              <div class="info-item-left">
                <div class="key">
                  <I18Lang id="user63" defaultText="银行卡号" />
                </div>
                <div class="value">{{ userInfo.bank_info.bank_no }}</div>
              </div>
            </div>

            <div class="info-item" v-if="userInfo.bank_info">
              <div class="info-item-left">
                <div class="key">Swift Code</div>
                <div class="value">{{ userInfo.bank_info.swift_code }}</div>
              </div>
            </div>
          </div>
          <BoxBank ref="boxBank" @onUpdata="onUpdata" />
        </div> -->
      </div>

    </div>
  </div>
</template>

<script>
import BoxPassword from './components/BoxPassword.vue'
import BoxBank from './components/Bank.vue'
import { mapState } from 'vuex'
import { userAuthStatusText } from '@utils/global'

export default {
  name: 'record',
  data () {
    return {
    }
  },
  methods: {
    onShow (name) {
      this.$refs[name].showDialog()
    },
    onUpdata () {
      this.$store.dispatch('getUserInfo')
    }
  },
  computed: {
    showAuthStatus () {
      return userAuthStatusText[this.userInfo.auth_status]
    },
    ...mapState(['userInfo'])
  },
  components: {
    BoxPassword,
    BoxBank
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url('../../../assets/img/k.png') no-repeat center / 100%;
    width: 936px;
    height: 640px;
    padding-top: 40px;
    padding-left: 65px;
    padding-right: 40px;
    margin: 0 auto;

    .user-info {
      padding-bottom: 32px;
      border-bottom: 1px solid rgb(#00CCFF, 0.3);

      .user {
        display: flex;

        .avatar {
          background: url('../../../assets/img/avatar-bg.png') no-repeat center / 100% 100%;
          width: 90px;
          height: 90px;
          flex: 0 0 90px;
          margin-right: 18px;

          img {}
        }

        .info {
          flex: 1;

          .nickname {
            font-size: 20px;
            font-weight: bold;
            color: #00CBFA;
            padding-top: 5px;
          }

          .user-id {
            font-size: 16px;
            display: block;
            font-family: Arial;
            font-weight: 400;
            color: #C9C9C9;
          }
        }
      }

      .info-tag {
        font-size: 12px;
        text-align: center;
        line-height: 21px;
        display: block;
        width: 164px;
        height: 21px;
        margin-top: 11px;
        cursor: pointer;
        text-shadow: 0px 0px 5px #C1F3FF;

        &.status1 {
          color: #FFE9F0;
          background: url('../../../assets/img/status-bg1.png') no-repeat center / 100% 100%;
        }

        &.status2 {
          color: #C1F3FF;
          background: url('../../../assets/img/status-bg2.png') no-repeat center / 100% 100%;
        }

        &.status3 {
          color: #FFEEB1;
          background: url('../../../assets/img/status-bg3.png') no-repeat center / 100% 100%;
        }

      }
    }

    .content {
      display: flex;
      justify-content: space-between;

      .left {
        padding-top: 49px;
        padding-left: 10px;
        width: 450px;
        flex: 0 0 450px;
      }

      .bank-info {
        position: relative;
        width: 368px;
        height: 269px;
        margin-top: 28px;
        background: url('../../../assets/img/xxbg.png') no-repeat center / 100%;

        .bank-info-title {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          display: block;
          height: 40px;
          line-height: 40px;
          padding-left: 15px;
          margin-bottom: 20px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          padding-left: 14px;
          padding-right: 32px;
          margin-bottom: 6px;

          .info-item-left {
            .key {
              font-size: 14px;
              color: #01B2F5;
              line-height: 18px;
            }

            .value {
              font-size: 16px;
              color: #FFFFFF;
            }
          }

          .info-item-right {
            &.kg-btn4 {
              min-width: 69px;
              height: 38px;
              line-height: 38px;
            }
          }
        }
      }

      .form-item {
        margin-bottom: 35px;
        position: relative;

        .form-item-label {
          font-size: 16px;
          color: #00CCFF;
        }

        .form-item-value {
          font-size: 16px;
          color: #FFFFFF;

          .btn {
            position: absolute;
            left: 280px;
            top: 0;
          }
        }
      }

    }
  }
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 188px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      height: auto;
      padding-top: 0;
      padding-left: 0;
      padding-right: 0;
      margin: 0 auto;

      .user-info {
        padding-bottom: 32px;
        border-bottom: 1px solid rgb(#00CCFF, 0.3);

        .user {
          display: flex;

          .avatar {
            background: url('../../../assets/img/avatar-bg.png') no-repeat center / 100% 100%;
            width: 90px;
            height: 90px;
            flex: 0 0 90px;
            margin-right: 18px;

            img {}
          }

          .info {
            flex: 1;

            .nickname {
              font-size: 20px;
              font-weight: bold;
              color: #00CBFA;
              padding-top: 5px;
            }

            .user-id {
              font-size: 16px;
              display: block;
              font-family: Arial;
              font-weight: 400;
              color: #C9C9C9;
            }
          }
        }

        .info-tag {
          font-size: 20px;
          text-align: center;
          line-height: 21px;
          display: block;
          width: 204px;
          height: 31px;
          line-height: 31px;
          margin-top: 11px;
          cursor: pointer;
          text-shadow: 0px 0px 5px #C1F3FF;

          &.status1 {
            color: #FFE9F0;
            background: url('../../../assets/img/status-bg1.png') no-repeat center / 100% 100%;
          }

          &.status2 {
            color: #C1F3FF;
            background: url('../../../assets/img/status-bg2.png') no-repeat center / 100% 100%;
          }

          &.status3 {
            color: #FFEEB1;
            background: url('../../../assets/img/status-bg3.png') no-repeat center / 100% 100%;
          }

        }
      }

      .content {
        display: block;

        .left {
          padding-top: 49px;
          padding-left: 10px;
          width: auto;
        }

        .bank-info {
          position: relative;
          width: auto;
          height: 350px;
          margin-top: 28px;
          background: url('../../../assets/img/xxbg.png') no-repeat center / 100% 100%;

          .bank-info-title {
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            display: block;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            margin-bottom: 20px;
          }

          .info-item {
            display: flex;
            justify-content: space-between;
            padding-left: 14px;
            padding-right: 32px;
            margin-bottom: 15px;

            .info-item-left {
              .key {
                font-size: 20px;
                color: #01B2F5;
                line-height: 18px;
              }

              .value {
                font-size: 20px;
                color: #FFFFFF;
              }
            }

            .info-item-right {
              &.kg-btn4 {
                min-width: 69px;
                height: 60px;
                line-height: 60px;
              }
            }
          }
        }

        .form-item {
          margin-bottom: 35px;
          position: relative;

          .form-item-label {
            font-size: 20px;
            color: #00CCFF;
          }

          .form-item-value {
            font-size: 20px;
            color: #FFFFFF;

            .btn {
              position: absolute;
              left: auto;
              right: 0;
              top: 0;
            }
          }
        }

      }
    }
  }
}
</style>
